import type { HourState } from 'redux/modules/hourStates.schema';
import { bootstrappedData } from 'utils/bootstrap';

export const defaultStateId = 0;

export const defaultState: HourState = {
  id: defaultStateId,
  account_id: bootstrappedData.account?.id ?? -1,
  name: 'Logged',
  icon: '',
  color: '',
  created_at: 0,
  updated_at: 0,
  billed: false,
  locked: false,
  system_managed: true,
  custom: false,
  deleted: false,
  permissions: [],
};
